
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-54152a56&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Funnel.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Funnel.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-54152a56!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Funnel.vue"),
  /* scopeId */
  "data-v-54152a56",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Funnel.vue
// module id = 298
// module chunks = 2